export default "__VITE_ASSET__4OueBTao__"